import _Plugin from "./_Plugin";
import PluginFactory from "./PluginFactory";
import {
	getAllWeights,
	getFontWeights,
} from "designSystem/fonts";
import html from "csi/html";
import { getFroalaSelectionSpanStyle } from "csi/service/fontService";
import { convertWeightToWord } from "csi/utility/fontUtility";
import TextToolbarSelect from "./TextToolbarSelect";

const options = getAllWeights();

const FontWeight = PluginFactory.declare([TextToolbarSelect, _Plugin], {
	bText: true,
	class: "svgSelect csi-text-formatting-select-button",
	cssStyle: "font-weight",
	normal: "normal",
	normalWeight: "400",
	pluginName: "fontWeight",
	title: "CanvasFontWeight",

	/**
	 * @override
	 * Populate font-weight store with all possible system weight values.
	 */
	postMixInProperties() {
		this.options = options.map((weight) => {
			// add style to dropdown menu
			const span = html.create("span", {
				style: { fontWeight: weight },
				innerText: convertWeightToWord(weight, true),
			});
			
			return { label: span.outerHTML, value: weight };
		});
		this.inherited(arguments);
	},

	/**
	 * Update plugin value and disabled status based on selected shapes and attributes
	 */
	enablePlugin(shapes: Object[], shapeAttrs: Object, textAttrs: Object): boolean {
		const { cssStyle, editor, normalWeight } = this;
		let value;
		if (shapes && shapes.length && editor.isSelectCanvasMode()) {
			value = editor.canvasApp.selection.getCommonTextValue(shapes, cssStyle, true) || normalWeight;
		} else if (editor.isEditTextCanvasMode()) {
			value = getFroalaSelectionSpanStyle(cssStyle) || normalWeight;
		}

		this.set("value", value, false);
		return true;
	},

	/**
	 * Dynamically show / hide content based on weight options available
	 */
	_onDropDownMouseDown(e: Event) {
		this.inherited(arguments);
		const { dropDown, editor, normalWeight } = this;
		const { selection } = editor.canvasApp;
		let fontFamily, fontStyle;
		if (editor.isEditTextCanvasMode()) {
			fontFamily = getFroalaSelectionSpanStyle("font-family") || "Arial";
			fontStyle = getFroalaSelectionSpanStyle("font-style") || "normal";
		} else {
			const selectedObjects = selection.selectedObjects();
			fontFamily = selection.getCommonTextValue(selectedObjects, "font-family", true) || "Arial";
			fontStyle = selection.getCommonTextValue(selectedObjects, "font-style", true) || "normal";
		}
		// style the dropdown with the parsed family.
		dropDown.domNode.style.fontFamily = fontFamily;
		const fontFamilyOptions = getFontWeights(fontFamily + fontStyle);
		const dropDownChildren = dropDown.getChildren();
		dropDownChildren.forEach((child) => {
			const { value } = child.option;
			if (fontFamilyOptions.includes(parseInt(value)) || value === normalWeight) {
				html.setVisible(child.domNode, true);
			} else {
				html.setVisible(child.domNode, false);
			}
		});
	},

	/**
	 * Apply style
	 */
	onChange(value: string) {
		const { cssStyle, editor } = this;
		editor.setTextStyle(cssStyle, value, true);

		// rerun enablePlugin to re-evaluate Bold button value
		editor._plugins.strong.enablePlugin();
	},
});

export = FontWeight;
